import { Activity } from "lucide-react";

const COLORS = ["text-amber-300", "text-sky-300", "text-emerald-300", "text-pink-300", "text-violet-300", "text-orange-300", "text-teal-300", "text-rose-300"];

export function CheckerPanel({ a }) {
  if (!a) return <div className="panel p-4 text-xs text-slate-500">Checking…</div>;
  const col = (l) => COLORS[(l.charCodeAt(0) - 65) % COLORS.length];
  return (
    <div className="panel p-4 space-y-3" data-testid="poem-checker">
      <p className="eyebrow flex items-center gap-1"><Activity size={12} />Rhyme & rhythm</p>
      <div className="flex flex-wrap gap-3 text-xs text-slate-300">
        <span data-testid="checker-lines">{a.line_count} lines · {a.stanzas} stanza{a.stanzas === 1 ? "" : "s"}</span>
        <span data-testid="checker-scheme">Rhyme: <span className="font-mono text-amber-200">{a.scheme || "—"}</span></span>
        <span data-testid="checker-meter">Meter: {a.meter_name || "no steady meter"}</span>
      </div>
      {a.issues.length > 0 ? <ul className="space-y-1" data-testid="checker-issues">{a.issues.map((x) => <li key={x} className="text-xs text-amber-400">• {x}</li>)}</ul> : <p className="text-xs text-emerald-300" data-testid="checker-ok">Fits the {a.form} form.</p>}
      <div className="max-h-[360px] overflow-y-auto scrollbar-thin border-t border-slate-800 pt-2">
        {a.lines.map((l) => l.blank ? <div key={l.n} className="h-2" /> : (
          <div key={l.n} className="grid grid-cols-[22px_26px_1fr_auto] gap-2 items-center text-[11px] py-0.5" data-testid={`checker-line-${l.n}`}>
            <span className="text-slate-600">{l.n}</span><span className="text-slate-300 text-right">{l.syllables}</span>
            <span className="font-mono text-slate-500 truncate" title={l.text}>{l.stress}</span>
            <span className={`font-mono ${col(l.rhyme)}`} title={l.near ? "near rhyme" : "rhyme"}>{l.rhyme}{l.near ? "~" : ""}</span>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-slate-500">Columns: line · syllables · stresses (/ stressed, x unstressed, ? either) · rhyme (~ near rhyme). {a.note}</p>
    </div>
  );
}
